import styled from 'styled-components'

const FooterStyles = styled.div`
	background-color: rgb(0%, 0%, 0%, 85%);
	color: white;
	font-family: 'comfortaa-bold';
`

export default FooterStyles
